import { InputRef, Input } from "antd"
import { useState, useRef, useEffect } from "react"

interface LazyInputProps {
  value?: string
  onChange?: (value: string) => void
  disabled?: boolean
}
export function LazyInput(props: LazyInputProps) {
  const {value: defaultValue, disabled, onChange} = props
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(defaultValue || '');
  const inputRef = useRef<InputRef>(null);

  useEffect(() => {
    setValue(defaultValue || '')
  }, [defaultValue])


  useEffect(() => {
    if (editing) {
      inputRef.current?.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
  };

  const save = (e) => {
    setValue(e.target.value)
    toggleEdit();
    onChange?.(e.target.value)
  };

  const content = <>
    {editing && <Input
      ref={inputRef}
      onPressEnter={save}
      onBlur={save}
      defaultValue={value}
      style={{width: '100%', height: 34, textAlign: 'right'}}
    />}
    {!editing && <div style={{width: '100%', textAlign: 'right'}}>{value}</div>}
  </>


  return (
    <div
      className="editable-cell-value-wrap"
      onClick={toggleEdit}
    >
      {content}
    </div>
  );
}